/** Leaves the admin for the network's consent screen; it returns through the API's callback. */
export function openAuthorization(url: string): void {
  window.location.assign(url);
}
